const CHANNEL_NAME = 'offercraft-auth'
const AUTH_CHANGED = 'AUTH_CHANGED'

let channel = null

function getChannel() {
  if (typeof BroadcastChannel === 'undefined') {
    return null
  }

  if (!channel) {
    channel = new BroadcastChannel(CHANNEL_NAME)
  }

  return channel
}

export function publishAuthChanged() {
  getChannel()?.postMessage({ type: AUTH_CHANGED })
}

export function subscribeToAuthChanges(handler) {
  const currentChannel = getChannel()

  if (!currentChannel) {
    return () => {}
  }

  const listener = (event) => {
    if (event.data?.type === AUTH_CHANGED) {
      handler()
    }
  }

  currentChannel.addEventListener('message', listener)

  return () => {
    currentChannel.removeEventListener('message', listener)
  }
}

export function closeAuthChannel() {
  channel?.close()
  channel = null
}
